import React from "react";
import "./services.css";

const services = [
  {
    title: "Web Development",
    image: "/Web Development.jpeg",
    details: [
      "Build dynamic, responsive websites and web applications using modern frameworks like React, Angular, Vue.js, and Next.js.",
      "Leverage headless CMS platforms like Contentful, Strapi, and Sanity for flexible content management.",
      "Employ serverless microservices architecture with AWS Lambda, Google Cloud Functions, or Azure Functions and cloud-native stack for scalable and cost-effective solutions.",
    ],
  },
  {
    title: "Web Design",
    image: "/Web Design.jpeg",
    details: [
      "Create stunning, user-centered designs that captivate your audience.",
      "Create imaginative artistic logos and web designs.",
      "Utilize industry-leading design tools like Figma, Adobe XD, and Sketch.",
      "Incorporate AI-powered design tools for efficient and creative workflows.",
    ],
  },
  {
    title: "Software & Application Development",
    image: "/SAD.jpeg",
    details: [
      "Develop custom software solutions tailored to your specific needs.",
      "Utilize powerful programming languages like Python, Java, C#, and JavaScript.",
      "Adopt cloud-native development principles and leverage platforms like AWS, Azure, and Google Cloud.",
    ],
  },
  {
    title: "Mobile App Development (Android & iOS)",
    image: "/MAD.jpeg",
    details: [
      "Build native and cross-platform mobile apps using Kotlin, Swift, React Native, and Flutter.",
      "Integrate AI and machine learning capabilities to enhance user experiences.",
      "Optimize apps for performance and user engagement.",
    ],
  },
  {
    title: "AI/ML Predictive Analysis",
    image: "/AI.jpeg",
    details: [
      "Harness the power of AI and machine learning to unlock valuable insights from your data.",
      "Utilize frameworks like TensorFlow, PyTorch, and Scikit-learn.",
      "Implement advanced techniques like natural language processing (NLP), computer vision, and predictive analytics.",
    ],
  },
  {
    title: "Generative AI",
    image: "/GenAI.jpeg",
    details: [
      "Leverage generative AI to create innovative content, automate tasks, and enhance decision-making.",
      "Create new generation Chat Bots with customized prompt engineering using Multi Modal Generative AI LLMs like ChatGPT, OpenAI, Gemini, etc.",
      "Explore tools like Midjourney, Stable Diffusion, and ChatGPT.",
      "Integrate generative AI into your workflows to boost productivity and creativity.",
    ],
  },
];

const Services = () => {
  return (
    <div className="services-container">
      <h1 className="services-heading">Our Core Services</h1>
      {services.map((service, index) => (
        <div key={index} className="service">
          <img src={service.image} alt={service.title} className="service-image" />
          <div className="service-content">
            <h2 className="service-title">{service.title}</h2>
            <ul className="service-details">
              {service.details.map((detail, idx) => (
                <li key={idx} className="detail-item">
                  {detail.split(" ").map((word, i) =>
                    word.match(/React|Next.js|AI|ML|Python|AWS|ChatGPT|Figma|TensorFlow/) ? (
                      <strong key={i}>{word} </strong>
                    ) : (
                      `${word} `
                    )
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Services;
